import { graphql } from "gql.tada";

export const ArticleSideBySideImageFragment = graphql(`
  fragment ArticleSideBySideImageFragment on ArticleSideBySideImages {
    _id
    left {
      url
      contentType
    }
    right {
      url
      contentType
    }
  }
`);
